export default "__VITE_ASSET__fc8930ed__"